<!-- 总订单收款列表 -->
<template>
    <div>
        <header v-if="isScreen" class="header">
            <p class="headerP1">筛选</p>
            <div style="height:0.34rem;border-right:1px solid #53B0A3;width: 1px;margin-right: 0.24rem;"></div>
            <el-input v-model="q.planId" placeholder="团号" size="small" style="width: 1.2rem;margin-right: 0.1rem;"
                      type="number"></el-input>
            <el-input v-model="q.id" placeholder="id" size="small" style="width: 1.2rem;margin-right: 0.1rem;"
                      type="number"></el-input>
            <el-input v-model="q.createName" placeholder="操作人" size="small" style="width: 1.2rem;margin-right: 0.1rem;"></el-input>
            <el-input v-model="q.chargingContent" placeholder="收款内容" size="small"
                      style="width: 1.2rem;margin-right: 0.1rem;"></el-input>
            <el-input v-model="q.payName" placeholder="付款方名称" size="small"
                      style="width: 1.2rem;margin-right: 0.1rem;"></el-input>
            <el-input v-model="q.collectionId" placeholder="订单编号" size="small"
                      style="width: 1.8rem;margin-right: 0.1rem;"></el-input>
            <el-date-picker v-model="q.payDateStr" placeholder="选择日期" size="small"
                            style="margin-right: 0.1rem;width: 1.5rem;" type="date" value-format="yyyy-MM-dd"
                            @change="page = 1, getList()">
            </el-date-picker>
            <el-input v-model="q.payPrice" placeholder="收款金额" size="small"
                      style="width: 1.2rem;margin-right: 0.1rem;"
                      type="number"></el-input>
            <el-select v-model="q.payType" placeholder="付款方式" size="small"
                       style="width: 1.2rem;margin-right: 0.1rem;" @change="page = 1, getList()">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-select v-model="q.status" placeholder="收款状态" size="small"
                       style="width: 1.2rem;margin-right: 0.1rem;" @change="page = 1, getList()">
                <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-button icon="el-icon-search" size="small" type="primary" @click="page = 1, getList()">查询</el-button>
            <el-button icon="el-icon-search" size="small" @click="resetClick">重 置</el-button>
        </header>
        <div style="padding: 0.15rem 0;color: red">
            勾选总金额： {{ checkTheTotalAmount }}¥
        </div>
        <footer class="footer">
            <div style="border: 1px solid #ebeef5">
                <el-table ref="multipleTable" :data="tableData"
                          :header-cell-style="{ backgroundColor: '#F1FAF9', color: '#000000' }"
                          :summary-method="getSummaries" border
                          show-summary style="width: 100%"
                          tooltip-effect="dark" @select="select" @select-all="selectAll">
                    <el-table-column align="center" fixed="left" type="selection" width="55"></el-table-column>
                    <el-table-column align="center" fixed="left" label="团号" prop="planId" width="180">
                        <template slot-scope="scope"> {{ scope.row.order.planId }}</template>
                    </el-table-column>
                    <el-table-column align="center" fixed="left" label="收款内容" width="180">
                        <template slot-scope="scope"> {{ scope.row.order.chargingContent }}</template>
                    </el-table-column>
                    <el-table-column align="center" label="收款时间" width="120">
                        <template slot-scope="scope"> {{ scope.row.payDate | dateFormat }}</template>
                    </el-table-column>
                    <el-table-column align="center" label="付款方名称" prop="payName" width="250"></el-table-column>
                    <el-table-column align="center" label="金额" prop="payPrice" width="150">
                        <template slot-scope="scope"> {{ scope.row.payPrice }}{{ scope.row.order.currency }}</template>
                    </el-table-column>
                    <el-table-column align="center" label="退款金额" prop="refundPrice" width="150"></el-table-column>
                    <el-table-column align="center" label="实际到帐金额" prop="actualArrival" width="150">
                        <template slot-scope="scope">
                            {{
                                scope.row.status === 0 || scope.row.status === 2 ? 0 : (scope.row.actualArrival * Number(scope.row.rate)).toFixed(2)
                            }} ¥
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="已开票金额" width="100">
                        <template slot-scope="scope">
                            {{ scope.row.invoicePrice ? '¥' + scope.row.invoicePrice : '未开票' }}
                        </template>
                    </el-table-column>
                    <el-table-column v-if="isRefund" align="center" label="退款提请金额" prop="refundPrice" width="180">
                        <template slot-scope="scope"> {{ Number(scope.row.refundPrice) }}</template>
                    </el-table-column>
                    <el-table-column align="center" label="付款方式" width="150">
                        <template slot-scope="scope"> {{ scope.row.payType == 1 ? '微信' : '线下转账' }}</template>
                    </el-table-column>
                    <el-table-column align="center" label="状态" width="150">
                        <template slot-scope="scope"> {{
                                scope.row.status === 0 || scope.row.status === 2 ? '未到账' : scope.row.status === 3 ? '退款中...' : '已到账'
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="备注" width="150">
                        <template slot-scope="scope"> {{ scope.row.remark }}</template>
                    </el-table-column>
                    <el-table-column align="center" prop="createName" label="操作人"></el-table-column>
                    <el-table-column align="center" prop="createCompanyName" label="操作公司"></el-table-column>
                    <el-table-column align="center" fixed="right" label="操作" width="80">
                        <template slot-scope="scope">
                            <el-button size="mini" style="background-color: #3EC8DD;border-color: #3EC8DD;"
                                       type="primary"
                                       @click="save(scope.row)">委托收款
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination :pageSizes="pageSizes" :totalNumber="totalNumber" @loadTable="loadTable"></pagination>
            </div>
        </footer>
        <el-dialog :visible.sync="dialogVisible1" title="委托收款" width="30%">
            <div>
                <p style="margin-bottom: 10px">请输入你要委托收款的供应商 ID</p>
                <el-input
                    v-model="checkObj.procurationCompanyId"
                    placeholder="请输入供应商ID"
                    style="width: 250px;"
                    type="number"
                ></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="confirmCommission">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import PayApi from "@/components/Api/pay";
import Pagination from '@/components/Pagination.vue';
import {uniqueByProperty} from "@/assets/utils/unit";

export default {
    components: {Pagination},
    computed: {
        checkTheTotalAmount() {
            let arr = this.selectList.filter(item => !(item.status === 0 || item.status === 2))
            return arr.reduce((acc, cur) => acc + (cur.payPrice * Number(cur.rate)), 0);
        }
    },
    props: {
        //是否可以筛选 
        isScreen: {
            type: Boolean,
            default: true
        },
        //是否显示退款提请金额
        isRefund: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectList: [],//勾选的数据
            value: '',
            pageSizes: [10, 20, 40, 80],
            tableData: [],
            page: 1,
            size: 10,
            totalNumber: 0,
            detailList: [],
            dialogVisible: false,
            dialogVisible1: false,
            text: '',
            supplierDatas: [],//供应商数据
            checkObj: {
                procurationCompanyId: null
            },
            options: [{
                value: 1,
                label: '微信支付'
            }, {
                value: '2',
                label: '线下转账'
            },],
            options1: [{
                value: 0,
                label: '未实付'
            }, {
                value: 1,
                label: '已实付'
            },
                {
                    value: 3,
                    label: '退款中'
                },
                {
                    value: 4,
                    label: '已退款'
                }
            ],
            q: {
                planId: '',
                chargingContent: '',//收款内容
                payDateStr: '',//收款时间
                payName: '',//付款方名称
                payType: '',//付款方式 1微信 2线下
                payPrice: null,//收款金额
                status: null,//收款状态
                createName:null,//操作人
                id: null,
                collectionId: null
            }
        }
    },
    mounted() {
        let query = this.$route.query
        if (JSON.stringify(query) != "{}") {
            this.q = {...this.q, ...query}
            //清楚路由传参
            this.$router.replace({query: {}})
        }
        if (this.isScreen) {
            this.getList()
        }
    },
    methods: {
        select(selection, row) {
            if (this.selectList.findIndex(n => n.id === row.id) === -1) {
                this.selectList.push(row)
            } else {
                this.selectList = this.selectList.filter(n => n.id !== row.id)
            }
        },
        selectAll(selection) {
            if (selection.length > 0) {
                this.selectList = uniqueByProperty([...this.selectList, ...selection], 'id')
            } else {
                this.tableData.forEach(item => {
                    this.selectList.splice(this.selectList.findIndex(n => n.id === item.id), 1)
                })
            }
        },
        save(item) {
            this.dialogVisible1 = true
            this.checkObj = item
        },
        //确定委托
        confirmCommission() {
            if (!this.checkObj.procurationCompanyId) {
                this.$message.warning('请选择供应商!')
            }
            new PayApi().procuration(this.checkObj).then(res => {
                if (res.status === 200) {
                    this.$message.error('委托成功!')
                    this.dialogVisible1 = false
                } else {
                    this.$message.error(res.data.statusText)
                }
            }).catch((err) => {
                this.$message.error('委托失败!')
            })
        },
getSummaries(param) {
            const {columns, data} = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                const values = data.map(item => item.status === 0 || item.status === 2 ? 0 : (Number(item[column.property]) * Number(item.rate)));
                if (index === 5 || index === 6 || index === 7) {
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0).toFixed(2);
                        sums[index] += '¥';
                    }
                }
            });
            return sums;
        },
        handlerSeeOrderClick(item) {
            this.dialogVisible1 = true
            console.log(item, 'dkk');
            this.detailList = item.collectionDetailList
        },
        loadTable(page, size) {
            this.page = page;
            this.size = size;
            this.getList()
        },
        resetClick() {
            this.q = {
                planId: null,
                chargingContent: '',//收款内容
                payDateStr: '',//收款时间
                payName: '',//付款方名称
                payType: '',//付款方式 1微信 2线下
                payPrice: null,//收款金额
                status: null,//收款状态
                createName:null,//操作人
            }
            this.page = 1
            this.getList()
        },
        getList() {
            this.size = this.q.planId ? 80 : 10
            this.pageSizes = this.q.planId ? [80, 100, 120, 140] : [10, 20, 40, 80]
            new PayApi("pay").totalCollection({page: this.page, size: this.size, q: this.q}).then(res => {
                if (res.status === 200) {
                    this.tableData = res.data.records
                    this.totalNumber = res.data.total
                    this.$nextTick(() => {
                        console.log(this.selectList, 'dldlldldldl')
                        this.tableData.forEach((item, index) => {
                            if (this.selectList.map(n => n.id).includes(item.id)) {
                                this.$refs.multipleTable.toggleRowSelection(item, true)
                            }
                        })
                    })
                    this.tableData.forEach(e => {
                        if (e.status == 5) {
                            this.$set(e, 'payPrice', -e.payPrice)
                        }
                        if (e.status == 3) {
                            this.$set(e, 'actualArrival', Number(e.payPrice))
                        } else {
                            this.$set(e, 'actualArrival', Number(e.payPrice) - Number(e.refundPrice))
                        }
                        //实际到帐金额

                    })
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    align-items: center;
    color: #53B0A3;
    margin-bottom: 0.2rem;

    .headerP1 {
        margin-right: 0.2rem;
    }
}
</style>